import React from 'react';

const DEFAULT_COUNT = 12;

export interface SrpResultsGridSkeletonProps {
  /** Number of placeholder cards (matches typical hitsPerPage). */
  count?: number;
}

/**
 * Placeholder grid while SRP results load (slim client payload or Algolia in flight).
 * Mirrors `.hit-card` + `hit-card__logo-mobile` / `hit-card__mobile-col` so swap to real HitCompactView is stable (lower CLS).
 */
export function SrpResultsGridSkeleton({ count = DEFAULT_COUNT }: SrpResultsGridSkeletonProps): React.ReactElement {
  return (
    <ul className="srp-results-grid" aria-busy="true">
      {Array.from({ length: count }, (_, i) => (
        <li key={i} className="srp-results-grid-item">
          <div
            className="hit-card min-h-[152px] pointer-events-none select-none shadow-none hover:shadow-none"
            aria-hidden
          >
            <div className="hit-card__leading-stack">
              <div className="hit-card__logo-mobile min-h-[72px] w-full shrink-0 rounded-xl bg-[#F2EADF] dark:bg-[#2A1D0F] animate-pulse" />
            </div>
            <div className="hit-card__main min-w-0 flex-1">
              <div className="hit-card__mobile-col min-w-0 flex-1 gap-2">
                <div className="h-4 w-[88%] max-w-xl rounded-md bg-[#EDE6DC] dark:bg-[#342415] animate-pulse" />
                <div className="h-3 w-[52%] rounded-md bg-[#EDE6DC]/85 dark:bg-[#342415]/85 animate-pulse" />
                <div className="hit-card__meta mt-auto flex flex-col gap-2 pt-1">
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="h-8 w-[4.5rem] shrink-0 rounded-lg bg-[#E5DDD4] dark:bg-[#3A2E22] animate-pulse" />
                    <span className="h-8 min-w-[6rem] flex-1 max-w-[160px] rounded-lg bg-[#DDE8DF]/90 dark:bg-[#1A2E22]/90 animate-pulse" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
      ))}
    </ul>
  );
}
